import { render, staticRenderFns } from "./ChartjsBarChart2.vue?vue&type=template&id=449ef50a&scoped=true&"
import script from "./ChartjsBarChart2.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart2.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChart2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChartjsBarChart2.vue?vue&type=style&index=1&id=449ef50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ef50a",
  null
  
)

export default component.exports